import { connect } from 'react-redux';
import AdvancedReportsView from './AdvancedReportsView';
import * as Actions from './AdvancedReportsActions';
import { externalHostSelector } from '../ConsumerArea/ConsumerAreaSelector';
import { selectPortalName } from '../CommonSelectors/CommonAreaSelector';

const AdvancedReportsContainer = connect(
  (state, ownProps) => {
    const clientId = ownProps.clientId;
    let subdivision = state.AdvancedReports.hasOwnProperty(clientId)
      ? state.AdvancedReports[clientId]
      : {};

    return Object.assign({}, subdivision, ownProps, {
      isAdviserArea: state.AdvancedReports.isAdviserArea,
      currentClientId: state.AdvancedReports.currentClientId,
      fpId: ownProps.fpId,
      isSaveEnabled: ADV.entities.isOptedIn('SaveAdvancedReport'),
      externalHost: externalHostSelector(state),
      portalName: selectPortalName(state),
    });
  },

  dispatch => ({
    initializeSection(clientId, isAdviserArea) {
      dispatch(Actions.initializeSection(clientId, isAdviserArea));
    },
    setSelectedReport(reportName, clientId, fpId) {
      dispatch(Actions.setSelectedReportByName(reportName, clientId, fpId));
    },
    requestData(clientId, isPrint, printSelectedReport, fpId, printDone) {
      dispatch(
        Actions.requestData(clientId, fpId, () =>
          dispatch(
            Actions.setSelectedReportByName(
              !isPrint || !printSelectedReport ? 'Investment Assets' : printSelectedReport,
              clientId,
              fpId,
              printDone,
            ),
          ),
        ),
      );
    },
    fetchSelectedReport(clientId, fpId, printDone, expandCurrentYear) {
      dispatch(Actions.fetchSelectedReport(clientId, fpId, printDone, expandCurrentYear));
    },
    changeSelectedReportStartYear(startYear, sortedColumns, clientId, fpId) {
      dispatch(Actions.changeSelectedReportStartYear(startYear, sortedColumns, clientId, fpId));
    },
    setColumns(columns, clientId, fpId) {
      dispatch(Actions.setColumns(columns, clientId, fpId));
    },
    put(selectedReport, clientId, fpId) {
      dispatch(
        Actions.saveReport(
          selectedReport.name,
          selectedReport.columns,
          selectedReport.startYear,
          selectedReport.isFirmLevelReport,
          clientId,
          fpId,
          () => {
            dispatch(Actions.setPopupOpen(false, clientId));
            dispatch(
              Actions.requestData(clientId, fpId, () =>
                dispatch(Actions.setSelectedReportByName(selectedReport.name, clientId, fpId)),
              ),
            );
          },
        ),
      );
    },
    deleteReport(name, clientId, fpId, isFirmLevelReport) {
      dispatch(
        Actions.deleteReport(name, clientId, fpId, isFirmLevelReport, () => {
          dispatch(
            Actions.requestData(clientId, fpId, () => {
              dispatch(Actions.changeSelectedReportName('', clientId));
              dispatch(Actions.changeSelectedReportType('', clientId));
              dispatch(Actions.changeReportFirmLevel(false, clientId));
            }),
          );
        }),
      );
    },
    openModal(clientId) {
      dispatch(Actions.setPopupOpen(true, clientId));
    },
    dismiss(clientId) {
      dispatch(Actions.setPopupOpen(false, clientId));
    },
    onCloseErrors(clientId) {
      dispatch(Actions.setErrors([], clientId));
    },
    onChangeName(value, clientId) {
      dispatch(Actions.changeSelectedReportName(value, clientId));
    },
    onChangeFirmLevel(isFirmLevelReport, clientId) {
      dispatch(Actions.changeReportFirmLevel(isFirmLevelReport, clientId));
    },
  }),
)(AdvancedReportsView);

export default AdvancedReportsContainer;
